import * as React from "react";
import * as angular from "angular";
import {connect, Provider} from 'react-redux';
import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import {default as reducers} from '../reducers/reducers';

import FeatureTypes from './FeatureTypes';
import FeatureView from './ViewFeatureType';
import {FetchDatacatalog, fetchDatacatalog, SelectContract, selectContract} from "../../../actions/actions";
import server from "../../../../integration/server/server-services";
import nvdbapi from "../../../../integration/nvdbapi/nvdbapi";
import security from '../../../../service/security/security-services';
import contractService from '../../../../service/contract/contract-services';
import datacatalog from "../../../../integration/datacatalog/datacatalog-services";
import FeaturesState, {PopupType} from "../domain/FeaturesState";
import SelectFeatureTypeModal from "./SelectFeatureTypeModal";
import {Fetch} from "../../../../service/Fetch";
import ImportRoadObjectModal from "./ImportRoadObjectModal";
import CreateObjectModal from "./CreateObjectModal/CreateObjectModal";

export class ServerHolder {
    constructor(
        public server: server = null,
        public security: security = null,
        public scope: angular.IRootScopeService = null,
        public contract: contractService = null,
        public nvdbapi: nvdbapi = null,
        public datacatalog: datacatalog = null,
        public fetch: Fetch = null,
    ) {}
}

const serverHolder = new ServerHolder();
const store = createStore(reducers, applyMiddleware(thunk.withExtraArgument(serverHolder)));

interface DispatchProps {
    selectContract: SelectContract;
    doFetchDatacatalog: FetchDatacatalog;
}

interface StateProps {
    contractId: string;
    isInitializing: boolean;
    isFetching: boolean;
    showingFullscreen: boolean;
    splitScreenDirection: string;
    popup: PopupType;
}

type Props = DispatchProps & StateProps;

class ContractFeaturesView extends React.Component<Props, {}> {
     componentDidMount() {
        const {contractId, isInitializing} = this.props;
        if (isInitializing) {
            serverHolder.security.ensureCurrentUser().then(user => {
                if (user) {
                    this.props.selectContract(contractId);
                    this.props.doFetchDatacatalog();
                } else {
                    serverHolder.security.startLogin();
                }
            }).catch(() => {
                serverHolder.security.startLogin();
            });
        }
    }

    render() {
        let popup = this.mapPopup();

        return <div>
            {this.props.isFetching && <div className="datafangst-loading"/>}
            {!this.props.showingFullscreen && <FeatureTypes />}
            <FeatureView activeTab={'contractFeatures'} />
            {popup}
            <ImportRoadObjectModal />
            <CreateObjectModal />
        </div>;
    }

    private mapPopup() {
        switch (this.props.popup) {
            case PopupType.COPY_FEATURE_WITH_TYPE:
                return (<SelectFeatureTypeModal />);

            default:
                return undefined;
        }
    }
}
interface ContractFeaturesProps {
    $routeParams: angular.route.IRouteParamsService;
    server: server;
    security: security;
    contract: contractService;
    nvdbapi: nvdbapi;
    datacatalog: datacatalog;
    $rootScope: angular.IRootScopeService;
}

export class ContractFeatures extends React.Component<ContractFeaturesProps, {}> {
    render() {
        const mapStateToProps = (state: FeaturesState) => {
            const contractid = this.props.$routeParams["contractId"];
            return {
                contractId: contractid,
                isInitializing: !state.isFetching && (!!state.contractId || state.contractId != contractid),
                isFetching: !!state.user && state.isFetching,
                showingFullscreen: state.showingFullscreen,
                splitScreenDirection: state.splitScreenDirection,
                popup: state.popup
            };
        };

        const mapDispachToProps = ({
            selectContract,
            doFetchDatacatalog: fetchDatacatalog,
        });

        const {server, security, contract, nvdbapi, datacatalog} = this.props;
        serverHolder.server = server;
        serverHolder.security = security;
        serverHolder.contract = contract;
        serverHolder.nvdbapi = nvdbapi;
        serverHolder.datacatalog = datacatalog;
        serverHolder.scope = this.props.$rootScope;
        serverHolder.fetch = new Fetch("", this.props.$rootScope);
        const App = connect(mapStateToProps, mapDispachToProps)(ContractFeaturesView);
        return <Provider store={store} key="provider">
            <App/>
        </Provider>;
    }
}